import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./../ODRPortal/ODRPortal.css";
import { trackEvent, trackPageView } from "../utils/tracking";

function ODRPortal() {
  useEffect(() => {
    trackPageView("https://www.jmfinancialmf.com/ODRPortal", "jmf_odr-portal");
    // trackPageView(
    //   "http://localhost:710/ODRPortal",
    //   "jmf_odr-portal"
    // );

    trackEvent({
      category: "Static Page",
      action: "ODRPortal Page Loaded",
      label: "jmf_odr-portal",
      value: 1,
    });
  }, []);
  // const [pathnamenew, setPathName] = useState('');

  return (
    <>
    
      <section className="ODRPortal-main">
        <nav aria-label="Breadcrumb">
        <Container>
          <Row>
            <Col>
              <ul className="navigator-arrow">
                <li>
                  <a href="/" aria-label="Home">
                    <i class="fa fa-home" aria-hidden="true"></i>
                  </a>{" "}
                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                </li>
                <li>
                  <a href="/ODRPortal">
                    <i>ODR-SCORES Portal</i>
                  </a>
                </li>
              </ul>
            </Col>
          </Row>
        </Container>

        </nav>

        <Container>
          <Row>
            <Col>
              <h1>Grievances Redressal Mechanism</h1>
              <div className="ODRPortal-div">
                <div className="ODRPortal-innerr-main">
                  <p>
                    At JM Financial Asset Management Limited/JM Financial Mutual
                    Fund, we believe in ensuring high service standards. As part
                    of this endeavour, we provide various avenues to reach out
                    for any queries or raise your grievances, if any.
                  </p>
                  <p>
                    If you are not satisfied with the resolution provided by us,
                    please click here to refer SEBI Circular and follow the
                    matrix to raise/escalate your grievances.
                  </p>
                  <p>
                    Further, you can also lodge a complaint in electronic mode
                    with SEBI on SEBI’s portal, 'SCORES' (SEBI Complaints
                    Redressal System), which is a centralized web based
                    complaints redress system.{" "}
                  </p>
                  <p>
                    The link to Online Dispute Resolution Portal (ODR Portal)
                    and SCORES website/ link to download mobile app is as
                    follows:
                  </p>{" "}
                </div>

                <div className="ODRportal-table ">
                  <table class="center table">
                    <tr>
                      <th>ODR Portal</th>
                      <td>
                        <a href="https://smartodr.in/login" target="blank">
                          ODR Portal
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <th>SEBI SCORES portal</th>
                      <td>
                        <a href="https://scores.sebi.gov.in/" target="blank">
                          SEBI SCORES portal
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        SEBI SCORES mobile<br></br> application - iOS
                      </th>
                      <td>
                        <a
                          href="https://apps.apple.com/in/app/sebiscores/id1493257302"
                          target="blank"
                        >
                          SEBI SCORES mobile application - iOS
                        </a>{" "}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        SEBI SCORES mobile <br></br>application - Android
                      </th>
                      <td>
                        <a
                          href="https://play.google.com/store/apps/details?id=com.sebi&hl=en_IN"
                          target="blank"
                        >
                          SEBI SCORES mobile application - Android
                        </a>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default ODRPortal;
